import { HttpClient, HttpInterceptorFn, HttpXsrfTokenExtractor } from '@angular/common/http';
import { inject } from '@angular/core';
import { StoreService } from '../services/store.service';
import { Router } from '@angular/router';
import { SecurityService } from '../services/security.service';

/**
 * HttpRequestInterceptor implements HttpInterceptor.
 * We’re gonna add withCredentials: true to make browser include Cookie on the Request header (HttpOnly Cookie).
 */
export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenExtractor = inject(HttpXsrfTokenExtractor);
  const router = inject(Router);
  const securityService = inject(SecurityService);
  console.log(req.url);
  if (!securityService.isAuthorized(router.url)) {
    router.navigateByUrl('/home');
  }
  let request = req.clone({ withCredentials: true });
  let storeService = inject(StoreService);
  //const headerName = 'X-XSRF-TOKEN';
  const token: string | null = storeService.getTokenJwt();

  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  return next(request);
};
